const MetricCard = ({ label, value, change, changeLabel, subtitle, icon: Icon }) => {
  return (
    <div className="metric-card">
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs font-medium text-gray-500 uppercase tracking-wide">{label}</span>
        {Icon && <Icon className="w-4 h-4 text-gray-400" />}
      </div>
      <p className="text-2xl font-semibold text-gray-900 tabular-nums">{value}</p>
      {subtitle && (
        <p className="mt-1 text-xs text-gray-500">{subtitle}</p>
      )}
      {change !== undefined && change !== null && (
        <p className={`mt-1 text-xs font-medium ${change >= 0 ? 'text-green-600' : 'text-red-600'}`}>
          {change >= 0 ? '+' : ''}{change}% {changeLabel || 'vs last month'}
        </p>
      )}
    </div>
  );
};

export default MetricCard;
